export const create = {
  createSuccessfully: 'Create new washing method successfully!',
}
